/** @format */

import LazyLoad from "./../../library/LazyLoad";
import Forms from "./../Forms";
import Tabs from "./../Tabs";
import Personalise from "./Personalise";
import Carousels from '../Carousels';
window.Carousels = Carousels;


export default class Attributes {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Attributes();
		self.attachEvents();
		self.updateTeamAddToBasketBtnAndPersonalise();
		self.setInitPositionTypeSelects();
		self.setInitApplicationOptions();
		self.toggleDisabledPersonaliseBtn();
		self.singleSizeCheck();
		self.handlePositionSelectDependency();
	}

	static setTeamPrice() {
		const self = new Attributes();
		self.setTeamPrice();
	}

	attachEvents() {
		const self = this;

		if ($(".js-product-team-quantity-rows").length > 0) {
			self.toggleDisabledPersonaliseBtn();
			self.addTeamQuantityRow();
			self.setPersonalisationData();
		}

		$(document).on("click", ".js-add-product-team-quantity-row", function (e) {
			e.preventDefault();
			self.addTeamQuantityRow();
			self.setPersonalisationData();
			self.recalcualteDiscountNumberandPrice();
			self.updateTeamAddToBasketBtnAndPersonalise();
			self.forwardOrders();
		});

		$(document).on("click", ".js-remove-product-team-quantity-row", function (e) {
			e.preventDefault();
			self.removeTeamQuantityRow($(this).parents(".js-product-team-quantity-row"));
			self.setPersonalisationData();
			self.setTeamPrice();
			self.updateTeamAddToBasketBtnAndPersonalise();
			self.recalcualteDiscountNumberandPrice();
			self.forwardOrders();
		});


		$(document).on("click", ".js-engraving-check", function (e) {
			self.setTeamPrice();
		});

		// Add event listener for sponsor redraw checkbox
		$(document).on("change", ".js-sponsor-is-redraw", function (e) {
			self.setTeamPrice();
			self.setSoloPrice();
		});

		// Badge price changes are handled via custom event fired by CustomBadge.js after
		// it writes the badge price to the DOM, guaranteeing correct calculation order.
		$(document).on('badge:price-updated', function () {
			self.setTeamPrice();
		});

		// Add event listener for sponsor enabled checkbox
		$(document).on("change", ".js-sponsor-check-input", function (e) {
			self.setTeamPrice();
			self.setSoloPrice();
		});

		$(document).on("change", ".js-product-team-quantity-size", function (e) {

			const $teamRow = $(this).closest(".js-product-team-quantity-row");
			const $target = $teamRow.length ? $teamRow : $(this);

			self.changeTeamQuantitySize($target);

			if ($teamRow.length) {
				let personalisationInputs = $teamRow.find(".js-product-page-personalisation-input");
				let stockcodeId = $teamRow.find(".js-product-stockcode-input").val();

				personalisationInputs.each(function () {
					let $input = $(this);
					$input.data("stockcode-id", stockcodeId);
				});

				self.setPersonalisationData();
			}

			self.setTeamPrice();
			self.updateTeamAddToBasketBtnAndPersonalise();

			if ($(".js-product-team-quantity-rows").length > 0) {
				self.toggleDisabledPersonaliseBtn();
			}
			self.updateFromPriceIfForwardOrder();

			// // By default hidden as size doesn't have a value - on change to a value - show prices
			// $(".product-team-quantity-total").show();
		});

		$(document).on("change", ".js-engraving-check", function (e) {

				self.setTeamPrice();
			});

		$(document).on("keyup change", ".js-plaque-line-input", function () {
			self.setTeamPrice();
		});

		$(document).on("click", ".js-copy-engraving-next-item, .js-copy-engraving-all-items, .js-remove-plaque-item-group", function () {
			setTimeout(function () {
				self.setTeamPrice();
			}, 0);
		});

		$(document).on("keyup change", ".js-product-page-personalisation-input", function (e) {
			self.setPersonalisationData();
			self.setTeamPrice();
			self.updateTeamAddToBasketBtnAndPersonalise();
		});

		$(document).on("change", 'select[name*="addOn"][name*="stockcode_id"]', function (e) {
			self.handlePositionSelectDependency();
		});

		$(document).on("change", ".js-reload-attributes", function (e) {
			self.reloadAttributes($(this));
			self.setPersonalisationData();
			self.setTeamPrice();
			self.updateTeamAddToBasketBtnAndPersonalise();
		});

		// Handle SS Colour dropdown changes to ensure proper image swapping
		$(document).on("change", ".js-ss-colour-dropdown", function (e) {
			const $dropdown = $(this);
			const $form = $dropdown.closest("form");
			const fieldType = $dropdown.data('field-type');
			const dropdownName = $dropdown.attr('name');
			
			// Check if this is an add-on dropdown (already in correct format) or attribute dropdown
			const isAddOnDropdown = dropdownName.indexOf('addOn[') === 0;
			
			let stockcodeId = null;
			if (isAddOnDropdown) {
				// Add-on dropdowns already have stockcode ID as the value
				stockcodeId = $dropdown.val();
			} else {
				// Attribute dropdowns need to get stockcode ID from data attribute
				const $selectedOption = $dropdown.find('option:selected');
				stockcodeId = $selectedOption.data('stockcode-id');
			}
			
			console.log('SS Colour dropdown changed:', {
				fieldType: fieldType,
				stockcodeId: stockcodeId,
				dropdownName: dropdownName,
				dropdownValue: $dropdown.val(),
				isAddOnDropdown: isAddOnDropdown
			});
			
			if (isAddOnDropdown) {
				console.log('Already add-on format, triggering reload directly');
				self.reloadAttributes($dropdown);
				self.setPersonalisationData();
				self.setTeamPrice();
				self.updateTeamAddToBasketBtnAndPersonalise();
				return;
			}
			
			let addOnId = null;
			if (fieldType === 'SS Colour') {
				addOnId = 2; // SS Colour add-on ID
			} else if (fieldType === 'Stock Trim Colour' || fieldType === 'Stock Trim Colour (Both)') {
				const $existingAddOnInputs = $form.find('input[name^="addOn["][name*="[stockcode_id]"]');
				$existingAddOnInputs.each(function() {
					const inputName = $(this).attr('name');
					const match = inputName.match(/addOn\[(\d+)\]\[stockcode_id\]/);
					if (match) {
						const existingAddOnId = parseInt(match[1]);
						if ([1, 11, 100, 101].includes(existingAddOnId)) {
							addOnId = existingAddOnId;
							return false;
						}
					}
				});
				if (!addOnId) {
					addOnId = 1;
				}
			}
			
			console.log('Determined addOnId:', addOnId);
			
			if (addOnId && stockcodeId) {
				let $hiddenInput = $form.find('input[name="addOn[' + addOnId + '][stockcode_id]"]');
				if ($hiddenInput.length === 0) {
					$hiddenInput = $('<input type="hidden">').attr('name', 'addOn[' + addOnId + '][stockcode_id]');
					$form.append($hiddenInput);
					console.log('Created hidden input:', 'addOn[' + addOnId + '][stockcode_id]');
				}
				$hiddenInput.val(stockcodeId);
				console.log('Set hidden input value:', stockcodeId);
			} else {
				console.log('Missing addOnId or stockcodeId:', { addOnId, stockcodeId });
			}
			
			self.reloadAttributes($dropdown);
			self.setPersonalisationData();
			self.setTeamPrice();
			self.updateTeamAddToBasketBtnAndPersonalise();
		});

		$(document).on("change", ".js-reload-bundle-attributes", function (e) {
			self.reloadBundleAttributes($(this));
		});

		$(document).on("change keyup", ".js-product-team-quantity-input", function () {
			self.changeTeamQuantitySize($(this).parents(".js-product-team-quantity-row"));
			self.setTeamPrice();
			self.forwardOrders();
			self.updateTeamAddToBasketBtnAndPersonalise();
			self.recalcualteDiscountNumberandPrice();

		});

		$(document).on(
			"ajax:request-success",
			"[data-team-personalisation-success]",
			function (event) {
				setTimeout(function () {
					self.setTeamPrice();
					self.createDiscountAmounts();
				}, 1);
			}
		);

		$(document).on(
			"ajax:request-success",
			"[data-personalisation-success]",
			function (event) {
				setTimeout(function () {
					self.setSoloPrice();
					self.createDiscountAmounts();
				}, 1);
			}
		);

		$(document).on("click", ".tabs-list.mod-product .js-tab-link", function (e) {
			e.preventDefault();

			// Reset red borders on change of tab
			$(".select2-container").removeClass("is-erroneous");

			self.updateTeamAddToBasketBtnAndPersonalise(); // update showing personalisaito btn
			// $(".product-price").hide();
		});

		$(document).on("click", ".js-tab-link-returns", function (e) {
			e.preventDefault();
			$(".returns-info-pill").removeClass("d-none")
			$(".returns-info-pill").addClass("d-flex")

			$(".tabs-body-dropdown").addClass("d-none");
			$(".tabs-body-dropdown").removeClass("d-flex");
		});

		$(document).on("click", ".js-tab-link-not-returns", function (e) {
			e.preventDefault();
			$(".returns-info-pill").addClass("d-none")
			$(".returns-info-pill").removeClass("d-flex")

			$(".tabs-body-dropdown").removeClass("d-none");
			$(".tabs-body-dropdown").addClass("d-flex");
		});

		$( document ).ready(function() {
    		self.createDiscountAmounts();
			self.createMaximumValue();
			$(".js-product-team-quantity-size").each(function() {
				self.changeTeamQuantitySize($(this));
			});
		});

		$(document).on("load", function () {
			self.toggleDisabledPersonaliseBtn();
		});

		$(document).on("click", ".js-position-option-hover", function (e) {
			e.preventDefault();
			if (
				!$(e.target).closest(".js-position-option-tooltip").length
			) {

				$(this).find(".js-position-option-tooltip").slideToggle();
			}

		});

		// On click of js-position-option-hover close all other js-position-option-tooltip
		$(document).on("click", ".js-position-option-hover", function (e) {
			e.preventDefault();
			$(".js-position-option-tooltip").not($(this).find(".js-position-option-tooltip")).hide();
		});

		$(document).on("click", ".js-position-option-tooltip-item", function () {
			var positionId = $(this).data("position-id");
			var positionName = $(this).find(".js-position-option-tooltip-text").text();
			$(".js-product-team-initials-input").data("position-id", positionId);
			$(".js-product-team-initials-input").attr("placeholder", positionName);
			$(".js-position-option-tooltip").hide();
		});

		$(document).on("click", function (e) {
			if (
				!$(e.target).closest(".js-position-option-hover").length &&
				!$(e.target).closest(".js-position-option-tooltip").length
			) {
				$(".js-position-option-tooltip").hide();
			}
		});

		$(document).on("click", ".js-position-colour-select", function (e) {
			e.preventDefault();
			var $this = $(this);
			var optionSelect = $this.closest(".js-position-option-hover").find(".js-position-option-select");
			var optionSelected = $this.closest(".js-position-option-hover").find(".js-position-option-selected");

			// Get position ID from data attributes
			var positionId = $this.data("position-id");

			// Find data-material-position-id with positionId value

			let materialName = $('[data-material-position-id="' + positionId + '"]').data("material-name");
			if (materialName) {
				if (materialName == "Embroidery") {
					materialName = "Emb";
				}
				optionSelected.find(".js-position-option-selected-text").text(materialName);
			}

			// Set the colour id to data-material-position-id data colour-id
			$('[data-material-position-id="' + positionId + '"]').data("colour-id", $this.data("colour-id"));

			optionSelect.hide();

			// Add border and 1px padding to the clicked js-position-colour-select
			$this.find(".colour-icon-box").css("border", "1px solid #000");
			$this.find(".colour-icon").css("padding", "2px");
			// Remove border from all other colour icons for this position
			$(".js-position-colour-select[data-position-id='" + positionId + "']").not($this).find(".colour-icon-box").css("border", "1px solid transparent");
			$(".js-position-colour-select[data-position-id='" + positionId + "']").not($this).find(".colour-icon").css("padding", "0px");

			optionSelected.find(".js-position-option-selected-colour").css("background-color", $this.data("colour-hex"));
			optionSelected.find(".js-position-option-selected-colour").show();
			optionSelected.find(".js-position-option-select-wheel").hide();
			//optionSelected.find(".js-position-option-selected-colour").css("border", "none");
			optionSelected.css("display", "flex");

			// Set personalisation data for the selected colour
			self.setPersonalisationData();
			self.setTeamPrice();
			self.updateTeamAddToBasketBtnAndPersonalise();
		});

		// on js-position-option-tooltip-close click, hide the tooltip
		$(document).on("click", ".js-position-option-tooltip-close", function (e) {
			e.preventDefault();
			$(this).closest(".js-position-option-tooltip").hide();
		});

		$(document).on("click", ".js-product-material-radio", function (e) {
			e.preventDefault();
			let $this = $(this),
				$radio = $this.find(".js-product-material-radio-input");
			// If the radio is not checked, check it and uncheck all others
			if (!$radio.is(":checked")) {
				// Uncheck all radios in the same group
				$this.parents(".js-product-team-material-select-group").find(".js-product-material-radio-input").prop("checked", false);
				// Check the clicked radio
				$radio.prop("checked", true);
				// Update the value of the hidden input
				let $hiddenInput = $this.parents(".js-product-team-material-select-group").find(".js-product-team-material-select");
				$hiddenInput.val($radio.val());
				$hiddenInput.data("material-position-id", $radio.data("position-id"));
				$hiddenInput.data("material-name", $radio.data("material-name"));

				// Update the text of the selected option
				let materialName = $radio.data("material-name") || $radio.val();
				let optionSelected = $this.closest(".js-position-option-hover").find(".js-position-option-selected");
				if (materialName == "Embroidery") {
					materialName = "Emb";
				}
				optionSelected.find(".js-position-option-selected-text").text(materialName);

				// Show the selected option
				let optionSelect = $this.closest(".js-position-option-hover").find(".js-position-option-select");
				optionSelect.hide();
				optionSelected.css("display", "flex");

				self.setPersonalisationData();
				self.setTeamPrice();
				self.updateTeamAddToBasketBtnAndPersonalise();
			}
		});

		$(document).on("change", ".js-product-team-material-select", function (e) {
			e.preventDefault();
			var $this = $(this);
			var materialName = $this.data("material-name") || $this.val();
			var optionSelect = $this.closest(".js-position-option-hover").find(".js-position-option-select");
			var optionSelected = $this.closest(".js-position-option-hover").find(".js-position-option-selected");

			optionSelect.hide();
			if (materialName == "Embroidery") {
				materialName = "Emb";
			}
			optionSelected.find(".js-position-option-selected-text").text(materialName);
			optionSelected.css("display", "flex");
		});

		// Show/hide this positions hover link and js-product-page-personalistion-input when the select js-product-team-position-type-select changes to the same position and type
		// This is used for the team personalisation inputs
		$(document).on("change", ".js-product-team-position-type-select", function (e) {

			//e.preventDefault();
			let $this = $(this),
				positionId = $this.data("position-id"),
				type = $this.find(':selected').val() ? $this.find(':selected').val() : "",
				positionType = positionId + "-" + type,
				$applicationColElements = $(".js-colour-application-col[data-position-id='" + positionId + "']"),
				$inputColElements = $(".js-product-page-personalisation-input-col[data-position-id='" + positionId + "']"),
				$positionTypeElements = $('[data-position-type="' + positionType + '"]');

			// Set values of other selects with the same position id to the same value if not already the same.
			// Exclude $this to avoid triggering a change on the element that just fired this handler.
			$(".js-product-team-position-type-select[data-position-id='" + positionId + "']").each(function () {
				let $select = $(this);
				if (this === $this[0]) return; // skip self to prevent infinite recursion
				if (($select.val() || "") !== type) {
					$select.val(type).trigger("change");
				}
			});

			$.each($inputColElements, function (index, element) {
				let $element = $(element),
					$colPositionType = $element.data("position-type");

				if (!type) {
					$element.find(".js-product-page-personalisation-input").prop("disabled", true);
				}

				if ($colPositionType === positionType) {
					$element.find(".js-product-page-personalisation-input").prop("disabled", false);
					$element.show();
				} else {
					$element.hide();
					$element.find(".js-product-page-personalisation-input").prop("disabled", false);
					$element.find(".js-product-page-personalisation-input").val("");
				}
			});

			self.setPersonalisationData();
			self.setTeamPrice();
			self.updateTeamAddToBasketBtnAndPersonalise();
		});

		// only allow letters in the initials input, limit to 4 characters and convert to uppercase
		$(document).on("change keyup", ".js-product-team-initials-input", function (e) {

			// Remove any non-letter characters
			this.value = this.value.replace(/[^a-zA-Z]/g, '').toUpperCase();
			this.trigger("change");

			let key = e.key;
			let value = $(this).val();

			// Allow backspace, delete, tab, escape, enter and arrow keys
			if (
				key === "Backspace" ||
				key === "Delete" ||
				key === "Tab" ||
				key === "Escape" ||
				key === "Enter" ||
				(key.length === 1 && key.match(/^[a-zA-Z]$/))
			) {
				if (value.length < 5) {
					$(this).val(value.toUpperCase());
				} else {
					e.preventDefault();
				}
			} else {
				e.preventDefault();
			}
		});

		// only allow numbers in the number input, limit to 2 characters
		$(document).on("change keyup", ".js-product-team-number-input", function (e) {

			this.value = this.value.replace(/\D/g, ''); // Remove non-numeric characters
			this.trigger("change");
			let key = e.key;
			let value = $(this).val();

			// Allow backspace, delete, tab, escape, enter and arrow keys
			if (
				key === "Backspace" ||
				key === "Delete" ||
				key === "Tab" ||
				key === "Escape" ||
				key === "Enter" ||
				(key.length === 1 && key.match(/^[0-9]$/))
			) {
				if (value.length < 3) {
					$(this).val(value);
				} else {
					e.preventDefault();
				}
			} else {
				e.preventDefault();
			}
		});

		// limit to 20 characters, allow only letters and disallow these characters: ?, &, ;, *, <, >, ", \', \ in one line
		$(document).on("change keyup", ".js-product-team-name-input", function (e) {
			this.value = this.value.replace(/[?&;*<>\"'\\]/g, '').substring(0, 20);
			// remove numbers
			this.value = this.value.replace(/[0-9]/g, '');
		});

		//do before the click is clicked

		let basketWarning = $(".js-product-forward-basket-warning");
		let	basketForwardOrderStatus = basketWarning.data("basket-forward-order-status");

		if (basketForwardOrderStatus == 'forward-order'){
			$('.js-team-basket-button').addClass("d-none");
		}

		$(document).on('change', '.js-forward-order-toggle', function() {


			let $this = $(this),
				isForwardOrder = $this.prop('checked'),
				productOriginalPrice = $this.data('price'),
				productforwardOrderPrice = $this.data('forward-order-price'),
				productPrice = $(".js-product-price"),
				productPriceValue = $('.js-product-team-quantity-price').find(".js-price-value"),
				teamPrices = $(".js-quantity-row-price"),
				quantityWarning = $(".js-product-forward-qty-warning"),
				basketWarning = $(".js-product-forward-basket-warning"),
				basketForwardOrderStatus = basketWarning.data("basket-forward-order-status"),
				basketCount = $('.js-basket-count').attr('data-count');


				if (isForwardOrder) {
					productPrice.addClass("text-success");
					productPriceValue.text(productforwardOrderPrice);
					$('.js-forward-order-input').val('1');
					quantityWarning.removeClass("d-none");

					if( basketCount >= 1 ){
						if (basketForwardOrderStatus == 'standard-order' || basketForwardOrderStatus == 'none') {
							basketWarning.removeClass("d-none");
							$('.js-team-basket-button').addClass("d-none");

						} else {

							basketWarning.addClass("d-none");
							$('.js-team-basket-button').removeClass("d-none");
						}
					}
					// Set input value since this toggle isn't within the form
					$('.js-forward-order-input').val('1');
				} else {
					productPrice.removeClass("text-success");
					productPriceValue.text(productOriginalPrice);
					$('.js-forward-order-input').val('0');
					quantityWarning.addClass("d-none");
					if( basketCount >= 1 ){
						if (basketForwardOrderStatus == 'forward-order') {
							basketWarning.addClass("d-none");
							$('.js-team-basket-button').removeClass("d-none");
						} else {
							basketWarning.removeClass("d-none");
							$('.js-team-basket-button').addClass("d-none");
						}
					}
					// Set input value since this toggle isn't within the form
					$('.js-forward-order-input').val('0');
				}

			teamPrices.each(function() {
				let el = $(this),
					originalPrice = el.data("price"),
					forwardOrderPrice = el.data("forward-order-price");

				// console.log("Original Price: " + originalPrice);
				// console.log("Forward Order Price: " + forwardOrderPrice);
				// console.log("Is Forward Order: " + isForwardOrder);
				// console.log("Element: ", el);
				// console.log("Quantity Price El: ", el.find('.js-product-team-quantity-price'));
					console.log("test function");

				if (isForwardOrder) {
					el.addClass("text-success");
					el.find('.js-product-team-quantity-price').text(forwardOrderPrice);
				} else {
					el.removeClass("text-success");
					el.find('.js-product-team-quantity-price').text(originalPrice);
				}
			});
			self.setTeamPrice();
			self.updateFromPriceIfForwardOrder();
		});
	}

	// If js-product-page-personalisation-input has value, check if the position has the colour/material selected, if not disable the add to basket button
	checkColourMaterialSelected() {
		let disable = false;
		$(".js-product-team-quantity-row").each(function () {
			let $row = $(this);
			$row.find(".js-product-page-personalisation-input").each(function () {
				let $input = $(this),
					positionId = $input.data("position-id"),
					type = $input.data("type");
				if ($input.val().length > 0) {
					// Check if the position has a colour selected
					let colourSelected = $('[data-material-position-id="' + positionId + '"]').data("colour-id") || "";
					let materialSelected = $('[data-material-position-id="' + positionId + '"]').val() || "";
					if (!colourSelected || !materialSelected) {
						disable = true;
						return false; // exit each loop
					}
				}
			});
			if (disable) {
				return false; // exit each loop
			}
		});
		return disable;
	}
	// If we have team quantity rows, check if any personalisation inputs have value, if so check if the colour/material is selected for that position, if not disable the personalise button
	toggleDisabledTeamBasketBtn() {
		let disable = false;
		disable = this.checkColourMaterialSelected();

		// Back orders do not require colour/material personalisation to be filled
		if ($(".js-team-basket-button").hasClass("no-submit")) {
			disable = false;
		}

		if (disable) {
			$(".js-team-basket-button").prop("disabled", true);
			$(".js-team-basket-button").addClass("is-disabled");
			$(".js-team-basket-button").attr("title", "Please select a colour and material for all personalised positions");
			// Show error message
			$(".js-product-team-application-error-message").show();
		} else {
			$(".js-team-basket-button").prop("disabled", false);
			$(".js-team-basket-button").removeClass("is-disabled");
			$(".js-team-basket-button").removeAttr("title");
			// Hide error message
			$(".js-product-team-application-error-message").hide();
		}
	}

	updateFromPriceIfForwardOrder(){
		// Check if forward order is enabled
		let isForwardOrder = $('.js-forward-order-toggle').prop('checked');
		if (isForwardOrder) {
			let productForwardOrderPrice = $('.js-product-team-quantity-price').html();
			productForwardOrderPrice = productForwardOrderPrice.replace('£', '').trim();

			let fromPrice = $('.js-product-price').find(".js-price-value").html();
			fromPrice = fromPrice.replace('£', '').trim();
			
			if(productForwardOrderPrice < fromPrice ){
				$('.js-product-price').find(".js-price-value").text(productForwardOrderPrice);
				$('.js-product-price').find(".js-price-value").addClass('forward-order-price');
			}
		}else{
			//restore normal price
			//check if forward-order-price is active , so it doesn't adjust the price between switch from med to large

			if($('.js-product-price').find(".js-price-value").hasClass('forward-order-price')) {
				$('.js-product-price').find(".js-price-value").removeClass('forward-order-price');
				let productOriginalPrice = $('.js-product-team-quantity-price').html();
				productOriginalPrice = productOriginalPrice.replace('£', '').trim();
				$('.js-product-price').find(".js-price-value").text(productOriginalPrice);
			}

		}
	}

	setPersonalisationData() {

		// On key up, build personalisation data array from data attributes


		// For each team quantity row
		$(".js-product-team-quantity-row").each(function () {
			let personalisationData = [];

			let $row = $(this);

			let stockcodeId = $row.find('.js-product-team-quantity-size').find('option:selected').data("stockcode-id"),
				positions = {};

			$row.find(".js-product-team-personalisations-input").val("");

			$row.find(".js-product-page-personalisation-input").each(function () {
				let $this = $(this),
					positionId = $this.data("position-id"),
					type = $this.data("type"),
					typeCustomName = $this.data("type-custom-name"),
					value = $this.val(),
					uuid = $this.data("uuid"),
					colour = $('[data-material-position-id="' + positionId + '"]').data("colour-id") || "",
					material = $('[data-material-position-id="' + positionId + '"]').val(),

					positionStockcodeId = $this.data("position-stockcode-id") || "";

					// Get the js-all-size-options for this position
					let sizeOptionJson = $(".js-all-size-options[data-position-id='" + positionId + "']");

					// Parse the JSON string to an object
					let sizeOptions = JSON.parse(sizeOptionJson.val() || "{}");
					// Get the first size for this type from the sizeOptions object
					let materialTypeKey = material + "_" + type + "_size";
					let size = sizeOptions[materialTypeKey] || "";
					// Get the first size for this type from the sizeOptions object
					let selectSize = Array.isArray(size) ? size[0] : size;

				if (value.length) {
					positions[positionId] = {
                        stockcode_id: positionStockcodeId,
                        type: type,
                        value: value,
                        uuid: uuid,
                        colour: colour,
                        material: material,
                        typeCustomName: typeCustomName,
						[material+"_"+type+"_size"]: selectSize.id,
                    };
				}
			});

			if (Object.keys(positions).length > 0) {
                let rowData = {};
                rowData[stockcodeId] = positions;
                personalisationData.push(rowData);
            }

			$row.find(".js-product-team-personalisations-input").val(JSON.stringify(personalisationData));
		});

		// Toggle the disabled state of the team basket button
		this.toggleDisabledTeamBasketBtn();
	}


	createDiscountAmounts(){
		if( $('.js-add-product-team-quantity-row').length === 0 ){
			$('.product-quantity-discounts').css('border-top', '1px solid #dbdbdb' )
			$('.product-quantity-discounts').css('margin-top', '1rem' )
		}
		let whatsInBasket = $(".amount-in-basket").text();
		if( whatsInBasket == 0 ){
			$('.quantity-avilable').show();
			$('.maximum-quantity-discounts').hide();
			$('.product-quantity-discount-info'	).hide();
		}
		let quantityfinder = $(".minimum-quantity");
		let uniquevalue = 0;
		if (quantityfinder.length > 0) {
			quantityfinder.each(function () {

				if( parseInt($(this).text()) > parseInt(whatsInBasket) && uniquevalue == 0){
					$('.next-discount').text($(this).text());
					let discountAmounts = parseInt($(this).text() ) - parseInt(whatsInBasket);
					$('.buy-more').text( discountAmounts ) ;
					$('.discount-amount').text( $(this).siblings('.discount-percentage').text() ) ;
					uniquevalue = 1;
					return false;

				}else if( parseInt(whatsInBasket) >= quantityfinder.last().text()  ){
					$('.maximum-quantity-discounts').show();
					$('.product-quantity-discount-info'	).hide();
				}
			});
		}
	}

	createMaximumValue(){
		let quantityadder = $(".product-quantity-discount");
		if (quantityadder.length > 0) {
			quantityadder.each(function (index) {
				let next = quantityadder.eq(index + 1);
				let nextNumber = next.find('.minimum-quantity').text();
				nextNumber = nextNumber -1;
				if (nextNumber > 0) {
					$(this).find('.maximum-quantity').text( nextNumber  );
				}else{
					$(this).find('.maximum-quantity').text("100000");
					$(this).find('.maximum-quantity').css('display', 'none');
					$(this).find('.dash').text("+");
					$(this).find('.dot').text("");
				}
			});
		}
	}


	recalcualteDiscountNumberandPrice(){
		let whatsInBasket = $(".amount-in-basket").text();
		let whatsOnThePage = 0;
		$('.product-quantity-discount-info'	).show();
		$('.quantity-avilable').hide();

		$(".js-product-team-quantity-input").each(function(){
			whatsOnThePage = whatsOnThePage + parseInt($(this).val());
		});

		let uniquevalue = 0;
		let fullTotal = parseInt(whatsInBasket) + parseInt(whatsOnThePage);
		let quantityfinder = $(".minimum-quantity");
		quantityfinder.each(function () {
			//readjusts the text on the fly
			if( parseInt($(this).text()) > parseInt(fullTotal) && uniquevalue == 0 ){
				$('.maximum-quantity-discounts').hide();
				$('.product-quantity-discount-info'	).show();
				let discountAmounts = parseInt($(this).text() ) - parseInt(fullTotal);
				$('.buy-more').text( discountAmounts ) ;
				$('.discount-amount').text( $(this).siblings('.discount-percentage').text() ) ;
				uniquevalue = 1;

				return false;

			}else if(  parseInt($(this).text()) >= quantityfinder.last().text()  ){
							$('.maximum-quantity-discounts').show();
							$('.product-quantity-discount-info'	).hide();
			}

		});
	}


	forwardOrders(){


		let minNumber = $(".js-minimum-order-quantity-forward-order").attr('data-forward-min-qty');
		minNumber = parseInt(minNumber)
		let whatsInBasket = 0;
		let whatsOnThePage = 0;

		$(".js-product-team-quantity-input").each(function(){
			whatsOnThePage = whatsOnThePage + parseInt($(this).val());
		});

		whatsInBasket = parseInt(whatsInBasket);
		whatsOnThePage = parseInt(whatsOnThePage);
		let totals = parseInt(whatsInBasket) + parseInt(whatsOnThePage);

		if( totals >= minNumber){
			$(".js-minimum-order-quantity-forward-order").addClass('d-none');
		}else{
			$(".js-minimum-order-quantity-forward-order").removeClass('d-none');

			let quantity = $(".js-minimum-order-quantity-forward-order").attr('data-forward-min-qty')
			quantity = parseInt(quantity);
			let amountLeft = quantity - totals;

			$('.js-forward-order-message').html('Please add ' + amountLeft + ' or more of this item to your basket, to meet forward order requirements' );



		}
	}

	reloadAttributes($attribute) {
		const self = this;

		let $this = $attribute,
			$form = $attribute.parents("form"),
			formData = $form.serializeArray(),
			data = {};

		$.each(formData, function () {
			data[this.name] = this.value;
		});

		let nameParts = $attribute.attr("name").split("[");
		nameParts = nameParts[1].split("]");
		let attributeId = nameParts[0];

		// pass in the attribute that has been changed incase we don't have a stockcode
		data["selectedAttribute"] = attributeId;

		const previousState = self.captureProductFormState($form);

		jax.progressBar.show();

		jax.ajax("shopProduct::onAttributeChangeCustom", {
			data: data,
			update: {
				"shopProduct/images/images": ".js-product-images",
				"shopProduct/images/images-grid": ".js-product-images-grid",
				"shopProduct/form": ".js-product-form-wrapper",
				"shopProduct/save": ".js-save-stockcode",
			},
			success: function (data, responseCode, xhr) {
				// If the ajax framework didn't automatically update the partials,
				// manually inject any returned partial HTML present in the response.
				try {
					const updateMap = {
						"shopProduct/images/images": ".js-product-images",
						"shopProduct/images/images-grid": ".js-product-images-grid",
						"shopProduct/form": ".js-product-form-wrapper",
						"shopProduct/save": ".js-save-stockcode",
					};

					if (data && typeof data === "object") {
						Object.keys(updateMap).forEach(function (partial) {
							if (data.hasOwnProperty(partial) && data[partial] !== undefined) {
								try {
									$(updateMap[partial]).html(data[partial]);
								} catch (e) {
									console.warn('Failed to inject partial:', partial, updateMap[partial], e);
								}
							}
						});
					}
				} catch (e) {
					console.warn('Error updating partials in reloadAttributes:', e);
				}

				jax.progressBar.hide();

				LazyLoad.watchNewElement('.media-product-images .product-img-wrapper [data-lazy-img]');
				LazyLoad.watchNewElement(".js-product-images [data-lazy-img]");
				LazyLoad.watchNewElement(".js-product-images-grid [data-lazy-img]");
				LazyLoad.watchNewElement(".js-product-form-wrapper [data-lazy-img]");
				LazyLoad.watchNewElement(".js-product-form-wrapper [data-lazy-svg]");
				Forms.initSelectPlugin($(".js-product-form-wrapper .js-select2"));

				self.addTeamQuantityRow();

				if (previousState) {
					self.restoreProductFormState(previousState, $attribute);
				}

				if ($(".js-product-team-quantity-rows").length > 0) {
					self.toggleDisabledPersonaliseBtn();
				}

				document.querySelectorAll('.product-img-wrapper img[data-lazy-img]').forEach(function(img) {
					img.src = img.getAttribute('data-lazy-img');
				});

				Carousels.init();

				self.reloadSlickDots();
				self.handlePositionSelectDependency();
			},
			complete: function (xhr, status) {
				jax.progressBar.hide();
			},
			error: function (xhr, status, error) {
				jax.progressBar.hide();
			}
		});
	}

	reloadBundleAttributes($attribute) {
		const self = this;

		let $this = $attribute,
			$form = $attribute.parents("form"),
			formData = $form.serializeArray(),
			data = {};

		$.each(formData, function () {
			data[this.name] = this.value;
		});

		let nameParts = $attribute.attr("name").split("[");
		nameParts = nameParts[1].split("]");
		let attributeId = nameParts[0];

		// pass in the attribute that has been changed incase we don't have a stockcode
		data["selectedAttribute"] = attributeId;

		const bundleFormState = self.captureProductFormState($form);

		const $selects = $(".js-product-bundle-form-wrapper .js-select2");

		$selects.each(function() {
			const $select = $(this);
			$select.prop("disabled", true).trigger("change.select2");
			$select.next(".select2-container").addClass("select2-container--disabled").css({
				"pointer-events": "none",
				"opacity": "0.5"
			});
		});

		jax.progressBar.show();

		jax.ajax("shopProduct::onAttributeChangeCustom", {
			data: data,
			update: {
				"shopProduct/bundle-form": ".js-product-bundle-form-wrapper",
				"shopProduct/save": ".js-save-stockcode",
			},
			success: function (data, responseCode, xhr) {

				// If the ajax framework didn't automatically update the partials,
				// manually inject any returned partial HTML present in the response.
				try {
					const updateMap = {
						"shopProduct/bundle-form": ".js-product-bundle-form-wrapper",
						"shopProduct/save": ".js-save-stockcode",
					};

					if (data && typeof data === "object") {
						Object.keys(updateMap).forEach(function (partial) {
							if (data.hasOwnProperty(partial) && data[partial] !== undefined) {
								try {
									$(updateMap[partial]).html(data[partial]);
								} catch (e) {
									console.warn('Failed to inject partial:', partial, updateMap[partial], e);
								}
							}
						});
					}
				} catch (e) {
					console.warn('Error updating partials in reloadBundleAttributes:', e);
				}

				jax.progressBar.hide();

				LazyLoad.watchNewElement(".js-product-bundle-form-wrapper [data-lazy-img]");
				LazyLoad.watchNewElement(".js-product-bundle-form-wrapper [data-lazy-svg]");
				Forms.initSelectPlugin($(".js-product-bundle-form-wrapper .js-select2"));

				if ($(".js-product-team-quantity-rows").length > 0) {
					self.toggleDisabledPersonaliseBtn();
				}

				$(".js-product-team-quantity-size").each(function() {
					self.changeTeamQuantitySize($(this));
				});

				if (bundleFormState) {
					self.restoreProductFormState(bundleFormState, $attribute);
				}

				document.querySelectorAll('.js-product-bundle-form-wrapper img[data-lazy-img]').forEach(function(img) {
					img.src = img.getAttribute('data-lazy-img');
				});

				Carousels.init();
			},
			complete: function (xhr, status) {
				jax.progressBar.hide();

				$selects.each(function() {
					const $select = $(this);
					$select.prop("disabled", false).trigger("change.select2");
					$select.next(".select2-container").removeClass("select2-container--disabled").css({
						"pointer-events": "",
						"opacity": ""
					});
				});
			},
			error: function (xhr, status, error) {
				jax.progressBar.hide();
			}
		});
	}

	captureProductFormState($form) {
		const state = {
			fields: {},
			rows: [],
			positionTypes: {},
			materialOptions: {},
			colourOptions: {},
			forwardOrder: false,
			files: {},
			fileMeta: {},
			sponsorSelections: {},
			plaqueEngravings: {}
		};

		if (!$form || !$form.length) {
			return state;
		}

		// Generic named fields. Radio groups are stored by the checked value;
		// checkboxes are stored as booleans; everything else by current value.
		$form.find(':input').each(function () {
			const $el = $(this);
			const name = $el.attr('name');

			if (!name || name.indexOf('team[') === 0) {
				return;
			}

			// Skip server-computed/duplicated fields that should come from the new render
			if (name === 'stockcode_id' || name === 'is_forward_order' || name === 'customisation_price' || name.indexOf('bundleStockcode[') === 0) {
				return;
			}

			if ($el.is(':checkbox')) {
				state.fields[name] = $el.is(':checked');
			} else if ($el.is(':radio')) {
				if ($el.is(':checked')) {
					state.fields[name] = $el.val();
				} else if (!state.fields.hasOwnProperty(name)) {
					state.fields[name] = '';
				}
			} else {
				state.fields[name] = $el.val();
			}
		});

		// Position type selects are UI-only (no name attribute)
		$('.js-product-team-position-type-select').each(function () {
			const $el = $(this);
			const positionId = $el.data('position-id');
			if (positionId && !state.positionTypes[positionId]) {
				state.positionTypes[positionId] = $el.val();
			}
		});

		// Material and colour choices per position
		$('.js-product-team-material-select').each(function () {
			const $el = $(this);
			const positionId = $el.data('material-position-id');
			if (positionId) {
				state.materialOptions[positionId] = {
					value: $el.val(),
					materialName: $el.data('material-name') || '',
					colourId: $el.data('colour-id') || ''
				};
			}
		});

		// Capture selected colour swatch per position (visual border is applied on click)
		$('.js-position-colour-select').each(function () {
			const $el = $(this);
			const positionId = $el.data('position-id');
			const border = $el.find('.colour-icon-box').css('border');
			if (
				border === '1px solid rgb(0, 0, 0)' ||
				border === '1px solid #000' ||
				border === '1px solid rgb(0,0,0)'
			) {
				state.colourOptions[positionId] = {
					colourId: $el.data('colour-id'),
					colourHex: $el.data('colour-hex'),
					colourName: $el.data('colour-name')
				};
			}
		});

		// Dynamic team rows
		$('.js-product-team-quantity-row').each(function () {
			const $row = $(this);
			const rowData = {
				size: $row.find('.js-product-team-quantity-size').val() || '',
				quantity: $row.find('.js-product-team-quantity-input').val() || '1',
				stockcode: $row.find('.js-product-team-quantity-stockcode').val() || '',
				personalisations: []
			};

			$row.find('.js-product-page-personalisation-input').each(function () {
				const $input = $(this);
				rowData.personalisations.push({
					positionId: $input.data('position-id'),
					type: $input.data('type'),
					value: $input.is(':checkbox') ? $input.is(':checked') : $input.val()
				});
			});

			state.rows.push(rowData);
		});

		// Keep File objects in memory so file uploads survive the partial re-render
		$form.find('input[type="file"]').each(function () {
			const $el = $(this);
			const id = $el.attr('id');
			const file = $el[0].files && $el[0].files[0];
			if (id && file) {
				state.files[id] = file;
				state.fileMeta[id] = { name: file.name };
			}
		});

		// Sponsor selected image / filename state
		$('.js-sponsor-check-input').each(function () {
			const $el = $(this);
			const positionId = $el.attr('id').replace(/^sponsor-/, '').replace(/-enable$/, '');
			const $wrapper = $el.closest('.product-sponsor-logo-wrapper');
			state.sponsorSelections[positionId] = {
				checked: $el.is(':checked'),
				selectedSponsorId: $wrapper.find('#selected_sponsor_' + positionId).val() || '',
				sponsorName: $wrapper.find('.js-sponsor-image.active').data('sponsor-name') || '',
				fileName: $wrapper.find('#sponsor-' + positionId + '-filename').val() || ''
			};
		});

		// Capture plaque engraving line inputs (these don't have name attributes)
		$('.js-plaque-line-input').each(function () {
			const $input = $(this);
			const engravingId = $input.data('engraving-id');
			const lineIndex = $input.data('line-index');
			const itemIndex = $input.closest('.js-plaque-item-group').data('item-index');

			if (engravingId !== undefined && lineIndex !== undefined && itemIndex !== undefined) {
				if (!state.plaqueEngravings[engravingId]) {
					state.plaqueEngravings[engravingId] = {};
				}
				if (!state.plaqueEngravings[engravingId][itemIndex]) {
					state.plaqueEngravings[engravingId][itemIndex] = {};
				}
				state.plaqueEngravings[engravingId][itemIndex][lineIndex] = $input.val();
			}
		});

		// Forward order checkbox state (duplicated with hidden input, use the visible toggle)
		state.forwardOrder = $('.js-forward-order-toggle').is(':checked');

		return state;
	}

	restoreProductFormState(state, $trigger) {
		const self = this;

		if (!state) {
			return;
		}

		const triggerName = $trigger && $trigger.attr('name') ? $trigger.attr('name') : null;

		const $form = $('.js-add-to-basket, .js-add-bundle-to-basket').first();
		if (!$form.length) {
			return;
		}

		const isReloadAttribute = function ($el) {
			return $el.hasClass('js-reload-attributes') || $el.hasClass('js-reload-bundle-attributes');
		};

		const setSelectValue = function ($select, value) {
			if (!$select || !$select.length) {
				return;
			}

			const escapedValue = String(value).replace(/"/g, '\\"');
			if (value && !$select.find('option[value="' + escapedValue + '"]').length) {
				return;
			}

			if ($select.hasClass('js-select2')) {
				$select.val(value).trigger('change.select2').trigger('change');
			} else {
				$select.val(value).trigger('change');
			}
		};

		const updateSizeHiddenFromRadio = function (name, value) {
			const matches = name.match(/^personalisation\[([^\]]+)\]\[(\d+)\]$/);
			if (!matches) {
				return;
			}
			const key = matches[1].replace(/_/g, '-');
			const positionId = matches[2];
			const $hidden = $('.js-product-team-' + key + '-select[data-size-position-id="' + positionId + '"]');
			if ($hidden.length) {
				$hidden.val(value);
			}
		};

		const restoreFileInput = function ($input, file) {
			if (!$input || !$input.length || !file) {
				return false;
			}
			try {
				const dt = new DataTransfer();
				dt.items.add(file);
				$input[0].files = dt.files;
				$input.trigger('change');
				return true;
			} catch (e) {
				return false;
			}
		};

		// Restore generic named fields
		$.each(state.fields, function (name, value) {
			if (triggerName && name === triggerName) {
				return;
			}

			const $el = $form.find('[name="' + name.replace(/"/g, '\\"') + '"]');
			if (!$el.length) {
				return;
			}

			// Server already renders these correctly; do not touch them so we
			// do not accidentally fire another attribute reload.
			if ($el.is('select') && isReloadAttribute($el)) {
				return;
			}

			if ($el.is(':checkbox')) {
				$el.prop('checked', !!value);
			} else if ($el.is(':radio')) {
				const $radio = $el.filter('[value="' + String(value).replace(/"/g, '\\"') + '"]');
				if ($radio.length) {
					$radio.prop('checked', true);
					updateSizeHiddenFromRadio(name, value);
				}
			} else if ($el.is('select')) {
				setSelectValue($el, value);
			} else {
				$el.val(value);
			}
		});

		// Restore forward order toggle and hidden input
		if (state.forwardOrder !== undefined) {
			$('.js-forward-order-toggle').prop('checked', state.forwardOrder);
			$('.js-forward-order-input').val(state.forwardOrder ? '1' : '');
		}

		// Restore position type selects (set value, then trigger change once per position)
		$.each(state.positionTypes, function (positionId, value) {
			const $selects = $('.js-product-team-position-type-select[data-position-id="' + positionId + '"]');
			if ($selects.length) {
				$selects.val(value).trigger('change.select2');
				$selects.first().trigger('change');
			}
		});

		// Restore material/colour per position
		$.each(state.materialOptions, function (positionId, data) {
			const $hidden = $('[data-material-position-id="' + positionId + '"]');
			if ($hidden.length) {
				$hidden.val(data.value);
				$hidden.data('material-name', data.materialName);
				$hidden.data('colour-id', data.colourId);
			}
		});

		// Initialize application options first (this may auto-select single colours)
		self.setInitApplicationOptions();

		// Restore selected colour by clicking the selected colour swatch (after init to override auto-selection)
		$.each(state.colourOptions, function (positionId, data) {
			const $colour = $('.js-position-colour-select[data-position-id="' + positionId + '"][data-colour-id="' + data.colourId + '"]');
			if ($colour.length) {
				$colour.trigger('click');
			}
		});

		// Restore team rows
		if (state.rows && state.rows.length) {
			const $wrapper = $('.js-product-team-quantity-rows');

			while ($wrapper.find('.js-product-team-quantity-row').length < state.rows.length) {
				self.addTeamQuantityRow();
			}

			while (
				$wrapper.find('.js-product-team-quantity-row').length > state.rows.length &&
				$wrapper.find('.js-product-team-quantity-row').length > 1
			) {
				$wrapper.find('.js-product-team-quantity-row').last().remove();
			}

			$wrapper.find('.js-product-team-quantity-row').each(function (index) {
				const rowData = state.rows[index];
				if (!rowData) {
					return;
				}

				const $row = $(this);
				const $size = $row.find('.js-product-team-quantity-size');

				if ($size.length && rowData.size) {
					setSelectValue($size, rowData.size);
				}

				const $quantity = $row.find('.js-product-team-quantity-input');
				if ($quantity.length) {
					$quantity.val(rowData.quantity);
				}

				if (rowData.personalisations && rowData.personalisations.length) {
					rowData.personalisations.forEach(function (personalisation) {
						const $input = $row.find(
							'.js-product-page-personalisation-input' +
							'[data-position-id="' + personalisation.positionId + '"]' +
							'[data-type="' + personalisation.type + '"]'
						);

						if (!$input.length || !$input.closest('.js-product-page-personalisation-input-col').is(':visible')) {
							return;
						}

						if ($input.is(':checkbox')) {
							$input.prop('checked', !!personalisation.value);
						} else if ($input.is('select')) {
							setSelectValue($input, personalisation.value);
						} else {
							$input.val(personalisation.value);
						}
					});
				}
			});
		}

		// Restore visibility / file state for option checkboxes
		// Engravings
		$('.js-engravings-input').each(function () {
			const $cb = $(this);
			const engravingId = $cb.attr('id').replace(/^engraving-/, '').replace(/-enable$/, '');
			const checked = !!state.fields[$cb.attr('name')];
			$cb.prop('checked', checked);

			const $tabs = $('.engraving-' + engravingId + '-tabs');
			if (checked) {
				$tabs.show();
			} else {
				$tabs.hide();
			}
			$cb.trigger('change');

			const fileId = 'engraving-upload-' + engravingId;
			if (state.files[fileId]) {
				restoreFileInput($('#' + fileId), state.files[fileId]);
			}

			// Restore engraving text input (notes field)
			const $notesInput = $('#engraving-notes-' + engravingId);
			if ($notesInput.length) {
				const notesFieldName = $notesInput.attr('name');
				if (state.fields[notesFieldName] !== undefined) {
					$notesInput.val(state.fields[notesFieldName]);
				}
			}

			// Restore plaque engraving line inputs
			if (state.plaqueEngravings && state.plaqueEngravings[engravingId]) {
				$.each(state.plaqueEngravings[engravingId], function (itemIndex, lines) {
					const $itemGroup = $('.js-plaque-item-group[data-item-index="' + itemIndex + '"]');
					if ($itemGroup.length) {
						$.each(lines, function (lineIndex, value) {
							const $lineInput = $itemGroup.find('.js-plaque-line-input[data-line-index="' + lineIndex + '"]');
							if ($lineInput.length) {
								$lineInput.val(value);
							}
						});
					}
				});
			}
		});

		// Sponsors
		$.each(state.sponsorSelections, function (positionId, data) {
			const $cb = $('#sponsor-' + positionId + '-enable');
			const $wrapper = $cb.closest('.product-sponsor-logo-wrapper');
			$cb.prop('checked', data.checked);

			const $tabs = $('.sponsor-' + positionId + '-tabs');
			if (data.checked) {
				$tabs.show();
			} else {
				$tabs.hide();
			}
			$cb.trigger('change');

			if (data.selectedSponsorId) {
				const $image = $wrapper.find('.js-sponsor-image[data-sponsor-id="' + data.selectedSponsorId + '"]');
				if ($image.length) {
					$image.addClass('active').siblings('.js-sponsor-image').removeClass('active');
					$('#selected_sponsor_' + positionId).val(data.selectedSponsorId);
					$('#sponsor_name_' + positionId).text(data.sponsorName);
					$wrapper.find('.sponsor-image-filename').removeClass('d-none');
				}
			}

			const fileId = 'sponsor-file-' + positionId;
			if (state.files[fileId]) {
				restoreFileInput($('#' + fileId), state.files[fileId]);
			} else if (data.fileName) {
				$('#sponsor-' + positionId + '-filename').val(data.fileName);
				const $label = $wrapper.find('.js-file-label');
				$label.find('.js-file-name').text(data.fileName).removeClass('d-none');
				$label.find('.js-file-remove').removeClass('d-none');
				$label.find('.js-file-label-text').addClass('d-none');
			}
		});

		// Custom badge
		$('.js-custom-badge-input').each(function () {
			const $cb = $(this);
			$cb.prop('checked', !!state.fields[$cb.attr('name')]);
			$cb.trigger('change');

			if (state.files['badge-artwork']) {
				restoreFileInput($('#badge-artwork'), state.files['badge-artwork']);
			}
		});

		// Recalculate prices, personalisation data and button states
		self.setPersonalisationData();
		self.setTeamPrice();
		self.updateTeamAddToBasketBtnAndPersonalise();
		self.handlePositionSelectDependency();
		self.recalcualteDiscountNumberandPrice();
		self.forwardOrders();

		// Re-initialise selects that may have been added dynamically
		Forms.initSelectPlugin($('.js-product-form-wrapper .js-select2, .js-product-bundle-form-wrapper .js-select2'));
	}

	addTeamQuantityRow() {
		const self = this;

		if ($(".js-product-team-quantity-row-markup").length > 0) {
			let markup = $(".js-product-team-quantity-row-markup").html(),
				$wrapper = $(".js-product-team-quantity-rows"),
				lastIndex =
					$wrapper.find(".js-product-team-quantity-row").length > 0
						? $wrapper.find(".js-product-team-quantity-row").last().data("index")
						: 0;

			// Capture the selected value from the last row
			let lastSelectedValue = $wrapper
				.find(".js-product-team-quantity-row")
				.last()
				.find(".js-product-team-quantity-size")
				.val();

			// Capture the number value from the last row
			let lastNumber = $wrapper
				.find(".js-product-team-quantity-row")
				.last().find(".js-product-team-number-input")
				.val();

			// Capture the team select input from the last row
			let lastTeamSelect = $wrapper
				.find(".js-product-team-quantity-row")
				.last()
				.find(".js-product-team-select-input")
				.val();

			markup = markup.replaceAll("{UUID}", Date.now() + '-' + Math.random().toString(36).substr(2, 9));
			markup = markup.replaceAll("{INDEX}", lastIndex + 1);

			$wrapper.append(markup);

			// Set the captured value in the new row
			if (lastSelectedValue) {
				$wrapper
					.find(".js-product-team-quantity-row")
					.last()
					.find(".js-product-team-quantity-size")
					.val(lastSelectedValue).trigger("change");

				let personalisationInputs = $wrapper
					.find(".js-product-team-quantity-row")
					.find(".js-product-page-personalisation-input");

				//personalisationInputs.each(function () {
				//	let $input = $(this);
					// Set the data attributes for the new input
				//	$input.data("stockcode-id", lastSelectedValue);
				//});
			}

			// Set the captured team select value in the new row
			if (lastTeamSelect) {
				$wrapper
					.find(".js-product-team-quantity-row")
					.last()
					.find(".js-product-team-select-input")
					.val(lastTeamSelect);

				// Trigger change event to update any dependent elements
				$wrapper
					.find(".js-product-team-quantity-row")
					.last()
					.find(".js-product-team-select-input").trigger("change");
			}

			// trigger all js-product-team-position-type-select change to show/hide the correct personalisation inputs
			$wrapper
				.find(".js-product-team-quantity-row")
				.last()
				.find(".js-product-team-position-type-select")
				.each(function () {
					let $this = $(this);
					$this.select2().trigger("change");
				});


			// Increment the number value in the new row
			if (lastNumber) {
				$wrapper
					.find(".js-product-team-quantity-row")
					.last()
					.find(".js-product-team-number-input")
					.val(parseInt(lastNumber) + 1);
			}

			let $newRow = $wrapper.find(".js-product-team-quantity-row").last();

			// If we only have 1 row, hide the remove button
			if ($wrapper.find(".js-product-team-quantity-row").length == 1) {
				$newRow.find(".js-remove-product-team-quantity-row").hide();
			} else {
				$newRow.find(".js-remove-product-team-quantity-row").show();
			}
			// If we have more than 1 row, show the remove button on all rows
			if ($wrapper.find(".js-product-team-quantity-row").length > 1) {
				$wrapper.find(".js-product-team-quantity-row").each(function () {
					$(this).find(".js-remove-product-team-quantity-row").show();
				});
			}

			self.reInitPositionTypeSelects();

			Forms.initSelectPlugin($wrapper.find(".js-select2"));
			LazyLoad.watchNewElement(".js-product-team-quantity-rows [data-lazy-svg]");

			$wrapper.find(".js-product-team-quantity-row").each(function () {
				self.changeTeamQuantitySize($(this));
			});

			self.setTeamPrice();

			setTimeout(function () {
				$wrapper.find(".js-toggle-accordion:last").trigger("click");
			}, 300);
		}

		return self;
	}

	removeTeamQuantityRow($row) {
		const self = this;

		// only remove if we have more than 1 row
		if ($(".js-product-team-quantity-row").length > 1) {
			$row.remove();

			// If we only have 1 row, hide the remove button
			if ($(".js-product-team-quantity-row").length == 1) {
				$(".js-product-team-quantity-row").find(".js-remove-product-team-quantity-row").hide();
			}
		}
	}

	setInitApplicationOptions() {
		// If js-product-team-material-select has value set the application options to show the correct ones
		$(".js-product-team-material-select").each(function () {
			let $this = $(this),
				materialName = $this.data("material-name") || $this.val(),
				positionId = $this.data("material-position-id"),
				optionSelect = $this.closest(".js-position-option-hover").find(".js-position-option-select"),
				optionSelected = $this.closest(".js-position-option-hover").find(".js-position-option-selected");

			if (materialName) {
				if (materialName == "Embroidery") {
					materialName = "Emb";
				}
				optionSelected.find(".js-position-option-selected-text").text(materialName);
				optionSelected.css("display", "flex");
				optionSelect.hide();
			}
		});

		// If only 1 js-position-colour-select for this position, trigger a click on it to select it
		$(".js-position-colour-select").each(function () {
			let $this = $(this),
				positionId = $this.data("position-id"),
				$colourOptions = $(".js-position-colour-select[data-position-id='" + positionId + "']");

			if ($colourOptions.length == 1) {
				$this.trigger("click");
			}
		});
	}

	changeTeamQuantitySize($row) {
		const self = this;

		if ($row.is(".js-product-team-quantity-size")) {
			const $size = $row,
				$group = $size.closest(".form-group"),
				$message = $group.find(".js-bundle-size-unavailable"),
				selectedValue = $size.val(),
				$sizeOption = $size.find('option[value="' + selectedValue + '"]'),
				stockcodeId = $sizeOption.data("stockcode-id"),
				stockValue = parseInt($sizeOption.data("stock-value"), 10) || 0,
				outOfStockMessage = $sizeOption.data("out-of-stock-message"),
				backInStockDate = $sizeOption.data("back-in-stock-date") != "" ? $sizeOption.data("back-in-stock-date") : false,
				isForwardOrder = $('.js-forward-order-toggle').prop('checked');

			if (!selectedValue) {
				$message.empty();
				return;
			}

			let html = "";
			let disableAddButton = false;
			const $bundleForm = $group.closest("form.js-add-bundle-to-basket");
			const $bundleButton = $bundleForm.length ? $bundleForm.find("button").first() : null;

			if (isForwardOrder) {
				html = "";
			} else if (outOfStockMessage == "preorder" || outOfStockMessage == "preorder_in_bundle") {
				html = '<p class="product-unavailable"><span>Pre-order Item</span></p>';
			} else if (outOfStockMessage == "backorder") {
				html =
					'<p class="product-unavailable"><span>Out of stock' +
					(backInStockDate ? " - Due " + backInStockDate : "") +
					'</span><a href="/en/popups/stock-notification/' +
					stockcodeId +
					'" class="js-popup">Email me when back in stock</a></p>';
			} else if (outOfStockMessage == "discontinued") {
				html = '<p class="product-unavailable">Out of stock - Not being replenished</p>';
				disableAddButton = true;
			} else if (stockValue < 1) {
				html =
					'<p class="product-unavailable"><span>Currently we only have ' +
					stockValue +
					' in stock</span></p>';
				disableAddButton = true;
			}

			if ($message.length) {
				$message.html(html);
			}

			if ($bundleButton && $bundleButton.length) {
				$bundleButton.prop("disabled", disableAddButton);
			} else {
				$(".js-team-basket-button").prop("disabled", disableAddButton);
			}

			return;
		}

		const $price = $row.find(".js-product-team-quantity-price");

		let price = 0;
		let forwardOrderPrice = 0;
		let isForwardOrder = $('.js-forward-order-toggle').prop('checked');

		if ($row.hasClass("mod-bundle")) {
			const $rows = $row.find(".js-product-team-bundle-quantity-row");

			$rows.each(function () {
				const $size = $(this).find(".js-product-team-quantity-size"),
					sizeVal = $size.val(),
					$stockcode = $(this).find(".js-product-team-quantity-stockcode");

				price += parseFloat($size.find('option[value="' + sizeVal + '"]').data("price"));

				$stockcode.val(sizeVal);
			});
		} else {
			const $size = $row.find(".js-product-team-quantity-size"),
				sizeVal = $size.val(),
				$stockcode = $row.find(".js-product-team-quantity-stockcode"),
				$quantity = $row.find(".js-product-team-quantity-input"),
				$sizeOption = $size.find('option[value="' + sizeVal + '"]'),
				$unavailable = $row.find(".js-product-team-unavailable"),
				stockcodeId = $sizeOption.data("stockcode-id"),
				stockValue = $sizeOption.data("stock-value"),
				outOfStockMessage = $sizeOption.data("out-of-stock-message"),
				backInStockDate =
					$sizeOption.data("back-in-stock-date") != ""
						? $sizeOption.data("back-in-stock-date")
						: false;

			price = $sizeOption.data("price");
			forwardOrderPrice = $sizeOption.data("forward-order-price");

			const setAvailableState = () => {
				if ($quantity.val() === "" || parseInt($quantity.val()) < 1) {
					$quantity.val(1);
				}
				$quantity.show();
				$unavailable.empty();
				$(".js-team-basket-button").prop("disabled", false);
			};

			if (isForwardOrder) {
				setAvailableState();
			} else if (outOfStockMessage == "preorder" || outOfStockMessage == "preorder_in_bundle") {
				if ($quantity.val() === "" || parseInt($quantity.val()) < 1) {
					$quantity.val(1);
				}
				$quantity.show();

				const hasSingleSize = $size.find("option:not([disabled])").length <= 1;

				if (!hasSingleSize) {
					$unavailable.html(
						'<p class="product-unavailable"><span>Pre-order Item</span></p>'
					);
				} else {
					$unavailable.empty();
				}
				$(".js-team-basket-button").prop("disabled", false);
			} else if (outOfStockMessage == "backorder") {
				if ($quantity.val() === "" || parseInt($quantity.val()) < 1) {
					$quantity.val(1);
				}
				$quantity.show();
				$unavailable.html(
					'<p class="product-unavailable"><span>Out of stock' +
					(backInStockDate ? " - Due " + backInStockDate : "") +
					'</span><a href="/en/popups/stock-notification/' +
					stockcodeId +
					'" class="js-popup">Email me when back in stock</a></p>'
				);
			} else if (outOfStockMessage == "discontinued") {
				$quantity.val(0).hide();
				$unavailable.html(
					'<p class="product-unavailable">Out of stock - Not being replenished</p>'
				);
			} else if (stockValue < $quantity.val()) {
				$unavailable.html(
					'<p class="product-unavailable"><span>Currently we only have ' +
					stockValue +
					" in stock</span></p>"
				);

				$(".js-team-basket-button").prop("disabled", true);
			} else {
				setAvailableState();
			}

			$stockcode.val(sizeVal);
		}

		price = parseFloat(price).toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);
		// Update the price display with 2 decimal places and locale formatting
		$price.text(price.toLocaleString(window.site.currency.locale, { minimumFractionDigits: 2 }));

		if (price && forwardOrderPrice) {
			price = parseFloat(price).toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);
			forwardOrderPrice = parseFloat(forwardOrderPrice).toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);
			// Update the price display with 2 decimal places and locale formatting

			$price.parent(".js-quantity-row-price").data("price", price);
			$price.parent(".js-quantity-row-price").data("forward-order-price", forwardOrderPrice);

			// Doesn't really need to ever use the else section but in there as a precaution
			if (isForwardOrder) {
				$price.text(forwardOrderPrice.toLocaleString(window.site.currency.locale, { minimumFractionDigits: 2 }));
				$price.parent(".js-quantity-row-price").addClass("text-success");
			} else {
				$price.text(price.toLocaleString(window.site.currency.locale, { minimumFractionDigits: 2 }));
				$price.parent(".js-quantity-row-price").removeClass("text-success");
			}
		} else if (price) {
			price = parseFloat(price).toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);
			// Update the price display with 2 decimal places and locale formatting
			$price.text(price.toLocaleString(window.site.currency.locale, { minimumFractionDigits: 2 }));
		}

		// If price is NaN, set to 0.00
		if (isNaN(price)) {
			$price.text("0.00");
		}
	}

	setTeamPrice() {
		const self = this,
			$rows = $(".js-product-team-quantity-row"),
			$selects = $(".js-product-team-quantity-size"),
			customisationPrice = $(".js-customisations-price").val();

		let total = 0,
			personalisations = 0,
			customisations = 0,
			sponsors = 0,
			engravings = 0,
			engravingSurcharges = self.getEngravingSurchargeTotal(),
			isForwardOrder = $('.js-forward-order-toggle').prop('checked');

		$rows.each(function () {
			let $selects = $(this).find(".js-product-team-quantity-size"),
				$inputs = $(this).find(".js-product-team-quantity-size"),
				$personalisation = $(this).find(".js-product-team-personalisations-input"),
				$engravings = $(".js-engravings-input:checked");

			let quantity = parseInt($(this).find(".js-product-team-quantity-input").val());

			if (quantity < 0) {
				quantity = 0;
			}

			let redrawPriceTotal = 0;
			// Add all sponsor inputs which are checked prices times quantity to total
		$(".js-sponsor-check-input:checked").each(function () {
			let sponsorPrice = parseFloat($(this).data("sponsor-price"));

			// for each sponsor js-sponsor-is-redraw input is checked, add redraw up redraw price
			let $redrawCheckbox = $(this).closest(".product-sponsor-logo-wrapper").find(".js-sponsor-is-redraw");
			if ($redrawCheckbox.is(":checked")) {
				let redrawPrice = parseFloat($redrawCheckbox.data("redraw-price"));
				redrawPriceTotal += redrawPrice;
			}

			sponsors += sponsorPrice;
		});

		sponsors = sponsors * quantity;
		sponsors = sponsors + redrawPriceTotal;
		sponsors = sponsors.toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);
		sponsors = parseFloat(sponsors);

		// console.log("Sponsors total: " + sponsors);

			$engravings.each(function () {
				engravings += parseFloat($(this).data("engraving-price") * quantity);
			});

			if ($personalisation.val()) {
				let personalisationData = JSON.parse($personalisation.val());

				let personalisationQuantity = $personalisation.parents(".js-product-team-quantity-row")
					.find(".js-product-team-quantity-input")
					.val();


				personalisations += parseFloat(
					Personalise.calculateTeamPersonalisationTotals(personalisationData) * personalisationQuantity
				);

			}

			customisations += parseFloat(customisationPrice) * quantity;

			$selects.each(function () {
				let $option = $(this).find('option[value="' + $(this).val() + '"]'),
					price = parseFloat(isForwardOrder ? $option.data("forward-order-price") : $option.data("price"));

				if ($option.length > 0) {
					total += price * quantity;
				} else {
					total += $(this).data("price") * quantity;
				}
			});
		});


		if (isNaN(total)) {
			total = 0;
		} else {
			total = total.toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);
		}

		//var subTotal = parseFloat(total);


		//$(".js-product-team-quantity-total-sub").text(
		//	subTotal.toLocaleString(window.site.currency.locale, { minimumFractionDigits: 2 })
		//);

		//$(".js-product-team-quantity-total-personalisations").text("0.00");

		var subTotal = parseFloat(total);

		$(".js-product-team-quantity-total-sub").text(
			subTotal.toLocaleString(window.site.currency.locale, { minimumFractionDigits: 2 })
		);

		/*if (personalisations > 0) {
			personalisations = personalisations.toFixed(2);
			$('.js-product-team-quantity-total-personalisations').text(personalisations.toLocaleString(window.site.currency.locale));
			$('.product-team-quantity-total-sub').show();
			$('.product-team-quantity-total-personalisations').show();
		} else {
			$('.product-team-quantity-total-sub').hide();
			$('.product-team-quantity-total-personalisations').hide();
		}*/

		$(".js-product-team-quantity-total-personalisations").text("0.00");

		$(".js-product-team-quantity-total-engravings").text("0.00");

		// Capture badge price BEFORE resetting (CustomBadge.js writes this value)
		let badges = parseFloat($(".js-product-team-quantity-total-badges").text()) || 0;
		$(".js-product-team-quantity-total-badges").text(badges.toFixed(2));

		if (personalisations > 0) {
			personalisations = personalisations.toFixed(
				window.site.currency.remove_decimal == "1" ? 0 : 2
			);
			personalisations = parseFloat(personalisations);

			$(".js-product-team-quantity-total-personalisations").text(
				personalisations.toLocaleString(window.site.currency.locale, {
					minimumFractionDigits: 2,
				})
			);
		} else {
			$(".js-product-team-quantity-total-personalisations").text("0");
		};

		if (customisations > 0 ) {
			// ensure customisations is a number
			customisations = parseFloat(customisations);

			// then format to fixed decimal places
			customisations = customisations.toFixed(
				window.site.currency.remove_decimal == "1" ? 0 : 2
			);
			$(".js-product-team-quantity-total-customisations").text(
				customisations.toLocaleString(window.site.currency.locale)
			);
		}
		if (engravings > 0) {
			engravings = engravings.toFixed(
				window.site.currency.remove_decimal == "1" ? 0 : 2
			);

		 engravings = parseFloat(engravings);

			// console.log(engravings);
			$(".js-product-team-quantity-total-engravings").text(
				engravings.toLocaleString(window.site.currency.locale, {
					minimumFractionDigits: 2,
				})
			);
		}

		if (engravingSurcharges > 0) {
			engravingSurcharges = parseFloat(engravingSurcharges).toFixed(
				window.site.currency.remove_decimal == "1" ? 0 : 2
			);
			engravingSurcharges = parseFloat(engravingSurcharges);
			engravings = parseFloat(engravings) + engravingSurcharges;
		}

		if (engravings > 0) {
			$(".js-product-team-quantity-total-engravings-row").removeClass("d-none");
			$(".js-product-team-quantity-total-engravings").text(
				parseFloat(engravings).toLocaleString(window.site.currency.locale, {
					minimumFractionDigits: 2,
				})
			);
		} else {
			$(".js-product-team-quantity-total-engravings-row").addClass("d-none");
			$(".js-product-team-quantity-total-engravings").text("0.00");
		}

		if (customisations > 0) {
			// ensure customisations is a number
			customisations = parseFloat(customisations);

			// then format to fixed decimal places
			customisations = customisations.toFixed(
				window.site.currency.remove_decimal == "1" ? 0 : 2
			);
			$(".js-product-team-quantity-total-customisations").text(
				customisations.toLocaleString(window.site.currency.locale, {
					minimumFractionDigits: 2,
				})
			);
		}

		if (sponsors > 0) {
			sponsors = parseFloat(sponsors).toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);
			sponsors = parseFloat(sponsors);

			$(".js-product-team-quantity-total-sponsors").text(
				sponsors.toLocaleString(window.site.currency.locale, {
					minimumFractionDigits: 2,
				})
			);
		}

		if (badges > 0) {
			$(".product-team-quantity-total-badges").show();
		} else {
			$(".product-team-quantity-total-badges").hide();
		}

		$(".product-team-quantity-total-sub").show();
		$(".product-team-quantity-total-personalisations").show();
		$(".product-team-quantity-total-sponsors").show();

		if (personalisations == 0) {
			$(".product-team-quantity-total-personalisations").hide();
		}

		if (sponsors == 0) {
			$(".product-team-quantity-total-sponsors").hide();
		}

		if (subTotal == total) {
			$(".product-team-quantity-total-sub").hide();
		}

		total =
			parseFloat(total) +
			parseFloat(personalisations) +
			parseFloat(sponsors) +
			parseFloat(customisations) +
			parseFloat(engravings) +
			parseFloat(badges);

		$(".js-product-team-quantity-total-sub").text(
			subTotal.toLocaleString(window.site.currency.locale, { minimumFractionDigits: 2 })
		);


		//discount calculator
		let whatsInBasket = $(".amount-in-basket").text();
		let whatsOnThePage = 0;
		$(".js-product-team-quantity-input").each(function(){
			whatsOnThePage = whatsOnThePage + parseInt($(this).val());
		});
		let fullTotal = parseInt(whatsInBasket) + parseInt(whatsOnThePage);

		let firstMinQtyValue = $('.minimum-quantity').first().text();
		let maxValues = $(".maximum-quantity");
		let uniquevalue = 0;

		if( fullTotal >=  parseInt(firstMinQtyValue) ){
			maxValues.each(function () {
				if( parseInt(fullTotal) <= parseInt($(this).text()) && uniquevalue == 0  ){
					let amountToDiscount =  $(this).siblings('.discount-percentage').text();
					let discounttext = `<p style= " display: inline-block; color: red; font-size: 13px; margin-left: 10px; " class="discount-amount-totals">includes ${amountToDiscount} Quantity discount </p>`;
					$('.discount-amount-totals').remove()
					$('.product-team-quantity-total-all').append(discounttext);
						amountToDiscount = amountToDiscount.replace(/[^0-9]/g, '');

					total = (total / 100) * parseInt(100 - amountToDiscount);
					uniquevalue = 1;
				}
			});
		}else{
			$('.discount-amount-totals').remove()
		}

		// total = total.toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);
		// newTotal = parseFloat(subtotal) + parseFloat(personalisations) + parseFloat(customisations) + parseFloat(engravings);
		// total = newTotal.toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);
		total = total.toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);

		$(".js-product-team-quantity-total-all").text(
			total.toLocaleString(window.site.currency.locale, {
					minimumFractionDigits: 2,
			})
		);

		// personalisation page inputs exist, hide personalisations line

		if ($(".js-product-team-personalisation-input").length > 0) {
			$(".product-team-quantity-total-personalisations").hide();
		}

		if (customisations == 0) {
			$(".product-team-quantity-total-customisations").hide();
		}

		if (subTotal == total) {
			$(".product-team-quantity-total-sub").hide();
		}
	}

	getEngravingSurchargeTotal() {
		let totalSurcharge = 0;

		$(".js-engravings-input:checked").each(function () {
			const engravingId = $(this).data("engraving-id");
			const $wrapper = $(`.js-plaque-engraving-wrapper[data-engraving-id="${engravingId}"]`);

			if ($wrapper.length === 0) {
				return;
			}

			const freeCharacterLimit = parseInt($wrapper.data("free-character-limit"), 10) || 0;
			const extraCharacterCost = parseFloat($wrapper.data("extra-character-cost")) || 0;

			$wrapper.find(".js-plaque-item-group").each(function () {
				let totalCharacters = 0;

				$(this).find(".js-plaque-line-input").each(function () {
					totalCharacters += ($(this).val() || "").length;
				});

				if (totalCharacters > freeCharacterLimit) {
					totalSurcharge += extraCharacterCost;
				}
			});
		});

		return totalSurcharge;
	}

	// Set type selects to the first not disabled option on page load
	setInitPositionTypeSelects() {
		const self = this;

		$(".js-product-team-position-type-select").each(function () {
			let $this = $(this);
			let $firstOption = $this.find("option:not(:disabled)").first();
			$this.val($firstOption.val());
			$this.trigger("change");
		});
	}

	reInitPositionTypeSelects() {
		const self = this;

		$(".js-product-team-position-type-select").each(function () {
			let $this = $(this);
			$this.trigger("change");
		});
	}

	setSoloPrice() {
		const self = this;

		let subtotal = parseFloat($(".js-product-solo-quantity-total-sub").text()),
			personalisations = 0,
			$personalisation = $(".js-personalisations");

		if ($personalisation.val()) {
			let personalisationData = JSON.parse($personalisation.val());
			let hasMultipleItems = personalisationData.length > 1 ? true : false;
			personalisationData = hasMultipleItems ? personalisationData : personalisationData[0];

			$.each(personalisationData, function (key, data) {
				if (hasMultipleItems) {
					personalisations += parseFloat(
						Personalise.calculateBundlePersonalisationTotals(data)
					);
				} else {
					personalisations += parseFloat(
						Personalise.calculatePersonalisationTotals(data)
					);
				}
			});
		}

		if (personalisations > 0) {
			$('.product-solo-quantity-total').show();
			$('.js-product-solo-quantity-total-personalisations').text(parseFloat(personalisations).toLocaleString(window.site.currency.locale));
		} else {
			$('.product-solo-quantity-total').hide();
		}

		 $(".product-solo-quantity-total").show();
		 personalisations = parseFloat(personalisations).toFixed(
		 	window.site.currency.remove_decimal == "1" ? 0 : 2
		 );
		 $(".js-product-solo-quantity-total-personalisations").text(
		 	parseFloat(personalisations).toLocaleString(window.site.currency.locale)
		 );

		// Calculate sponsor totals
		let sponsors = 0;
		$(".js-sponsor-check-input:checked").each(function () {
			let sponsorPrice = parseFloat($(this).data("sponsor-price")) || 0;
			let $redrawCheckbox = $(this).closest(".product-sponsor-logo-wrapper").find(".js-sponsor-is-redraw");
			if ($redrawCheckbox.is(":checked")) {
				let redrawPrice = parseFloat($redrawCheckbox.data("redraw-price")) || 0;
				sponsors += redrawPrice;
			}
			sponsors += sponsorPrice;
		});

		if (sponsors > 0) {
			$(".product-solo-quantity-total-sponsors").show();
			$(".js-product-solo-quantity-total-sponsors").text(
				parseFloat(sponsors).toLocaleString(window.site.currency.locale)
			);
		} else {
			$(".product-solo-quantity-total-sponsors").hide();
		}

		if (subtotal) {
			let total = parseFloat(subtotal) + parseFloat(personalisations) + parseFloat(sponsors);
			total = total.toFixed(window.site.currency.remove_decimal == "1" ? 0 : 2);
			$(".js-product-solo-quantity-total-all").text(
				parseFloat(total).toLocaleString(window.site.currency.locale)
			);
		}
	}

	updateTeamAddToBasketBtnAndPersonalise() {
		const self = this;

		const $wrapper = $(".js-product-team-quantity-rows");

		let totalStock = 0;

		$wrapper.find(".js-product-team-quantity-row").each(function () {
			const $size = $(this).find(".js-product-team-quantity-size"),
				sizeVal = $size.val(),
				$sizeOption = $size.find('option[value="' + sizeVal + '"]'),
				// outOfStockMessage = $sizeOption.data("out-of-stock-message"),
				stockValue = $sizeOption.data("stock-value");

			totalStock += stockValue;
		});

		if (totalStock === 0) {
			$(".js-team-basket-button").text("Back Order");
			$(".js-team-basket-button").addClass("no-submit");
			$("#product-team .js-personalise-link").hide();
		} else {
			$(".js-team-basket-button").text("Add To Basket");
			$(".js-team-basket-button").removeClass("no-submit");
			$("#product-team .js-personalise-link[data-team]").show();
		}

		return self;
	}

	toggleDisabledPersonaliseBtn() {
		$(".js-product-stockcode-input").each(function () {
			if ($(this).val()) {
				$(".js-personalise-link").removeClass("mod-disabled");
			} else {
				$(".js-personalise-link").addClass("mod-disabled");
			}
		});
	}

	reloadSlickDots() {
		$('.js-carousel.slick-initialized').slick('setPosition');
	}


	singleSizeCheck() {
		if ($(".js-single-size-option").length > 0) {
			$(".js-product-team-quantity-size").trigger("change");
		}
	}

	validateQuantity($quantityInput) {
		const val = parseInt($quantityInput.val());

		if (val < 1 || isNaN(val) || val === undefined) {
			$quantityInput.val(1);
		}

		return this;
	}

	handlePositionSelectDependency() {
		const self = this;

		// for each select with addOn and stockcode_id in the name with a value, find the select with postion_id in the name and the same addon group number and add the js-basket-required-team-field class to it if a value is selected
		$("select[name*='addOn'][name*='stockcode_id']").each(function () {
			let $this = $(this),
				name = $this.attr("name"),
				value = $this.val();

			let nameParts = name.split("["),
				addOnGroup = nameParts[1].split("]")[0],
				positionSelect = $("select[name*='addOn'][name*='[" + addOnGroup + "]'][name*='position_id']");

			if (positionSelect.length > 0) {
				if (value) {
					positionSelect.addClass("js-basket-required-field js-basket-required-team-field");
				} else {
					positionSelect.removeClass("js-basket-required-field js-basket-required-team-field");
				}
			}
		});

	}
}
